import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { DateTime, Duration } from "luxon"
import Text from "./Text"

/** Timestamp displays a date/time in a consistent manner. */
const Container = styled.div`
  color: white;
`
const Time = styled.div`
  font-weight: bold;
  color: ${(props) => props.color || props.theme.colours.text.primary};
  white-space: nowrap;
`
const Date = styled.div`
  color: ${(props) => {
    return props.color || props.theme.colours.text.secondary
  }};
  white-space: nowrap;
`

const Timestamp = ({
  children,
  utc = false,
  color,
  date = true,
  time = true,
  columnMode = false,
  prefix = "",
  flagOlderThan = undefined, // ISO duration, e.g. "P7D" for a week
}) => {
  let t = undefined
  if (utc === true) {
    t = DateTime.fromISO(children).toUTC()
  } else {
    t = DateTime.fromISO(children)
  }

  // Should we flag an old timestamps?
  let flagAsOld = false
  if (flagOlderThan) {
    const now = DateTime.now()
    const olderThan = Duration.fromISO(flagOlderThan).as("second")
    const age = now.diff(t).as("second")
    flagAsOld = age > olderThan
  }
  let col = flagAsOld ? "#777" : color
  return columnMode ? (
    <Container>
      {time && (
        <Time color={col}>
          {prefix ? prefix + " " : ""}
          {t.toLocaleString(DateTime.TIME_24_WITH_SHORT_OFFSET)}
        </Time>
      )}
      {date && <Date color={col}>{t.toISODate()}</Date>}
    </Container>
  ) : (
    <Container>
      <Date color={col}>
        {prefix ? prefix + " " : ""}
        {date && t.toISODate()}{" "}
        {time && t.toLocaleString(DateTime.TIME_24_WITH_SHORT_OFFSET)}
      </Date>
    </Container>
  )
}

Timestamp.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string, // optionally specify a text color
  utc: PropTypes.bool, // Shows in UTC
  date: PropTypes.bool, // Show date part
  time: PropTypes.bool, // Show time part
  columnMode: PropTypes.bool, // if true the Timestamp will be rendered on 2 lines with time above and highlighted
  prefix: PropTypes.string, // Optional string prefix to render before the timestamp
}

export default Timestamp
